module.exports = __webpack_public_path__ + "img/thumbnail_Saiga_j_normal.57dfa47a.png";